import { LoanRepayment } from "@/modules/transaction/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const LoanRepaymentPage = ({ isEdit, isCopy }: IOperationPageProps) => (
  <LoanRepayment isCopy={isCopy} isEdit={isEdit}/>
);
